import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function NavBar({ onLogout }) {
  const location = useLocation();

  return (
    <nav className="modern-nav">
      <div className="nav-center">
        <Link
          to="/"
          className={location.pathname === "/" ? "nav-item active" : "nav-item"}
        >
          🏠 Dashboard
        </Link>
        {/* <Link
          to="/home"
          className={location.pathname === "/home" ? "nav-item active" : "nav-item"}
        >
          🏠 Home
        </Link> */}
        <Link
          to="/inventory"
          className={
            location.pathname === "/inventory" ? "nav-item active" : "nav-item"
          }
        >
          📦 Inventory
        </Link>
        <Link
          to="/category"
          className={
            location.pathname === "/category" ? "nav-item active" : "nav-item"
          }
        >
          🛒 Category
        </Link>
        <Link
          to="/products"
          className={
            location.pathname === "/products" ? "nav-item active" : "nav-item"
          }
        >
          🍗 Products
        </Link>
        <Link
          to="/orders"
          className={
            location.pathname === "/orders" ? "nav-item active" : "nav-item"
          }
        >
          📊 Orders
        </Link>
        <Link
          to="/reports"
          className={
            location.pathname === "/reports" ? "nav-item active" : "nav-item"
          }
        >
          📊 Reports
        </Link>
      </div>
      <button className="logout-btn" onClick={onLogout}>
        🚪 Logout
      </button>
    </nav>
  );
}
